import { capitalizeAllIfLower } from '@btime/helpers'
import { compose, join, map, prop, propOr } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useSegment } from './_load/SegmentLoader'
import FlexGrid, { FlexCol } from '../../../components/structure/FlexGrid'
import LabelValue from '../../../components/presentation/LabelValue'
import formatLocalPersonLabel from '../_helpers/formatLocalPersonLabel'
import { usePlaceTypes } from '../../../utils/helpers/placeTypes'

const SegmentationDetails = () => {
  const { t } = useTranslation('editSegmentation')
  const [placeTypes] = usePlaceTypes()
  const segment = useSegment()

  const segmentServiceType = compose(
    join(', '),
    map(compose(capitalizeAllIfLower, prop('name'))),
    propOr([], 'checklistTypes')
  )(segment)

  const placeLevelsByPlaceType = placeTypes.map(type => {
    return {
      type,
      placeLevels: segment.placeLevels
        .filter(item => item.type === type.key)
        .map(item => formatLocalPersonLabel(item))
        .join(', ')
    }
  })

  const hasAllPlacesSelected = !segment.placeLevels.length

  const segmentUserGroup = compose(
    join(', '),
    map(compose(capitalizeAllIfLower, prop('name'))),
    propOr([], 'userGroups')
  )(segment)

  const segmentAssets = compose(
    join(', '),
    map(compose(capitalizeAllIfLower, prop('name'))),
    propOr([], 'assets')
  )(segment)

  return (
    <FlexGrid justify="flex-start" align="flex-start" paddingGutter={0.5} wrap>
      <FlexCol width="50%">
        <LabelValue
          label={t('checklistTypes.title')}
          children={segmentServiceType.length ? segmentServiceType : t('ignoring')}
        />
      </FlexCol>

      <FlexCol width="50%">
        <LabelValue
          label={t('groupStep.title')}
          children={segmentUserGroup.length ? segmentUserGroup : t('ignoring')}
        />
      </FlexCol>

      <FlexCol width="50%">
        <LabelValue label={t('assetStep.title')} children={segmentAssets.length ? segmentAssets : t('ignoring')} />
      </FlexCol>

      {placeLevelsByPlaceType.map(item => {
        if (hasAllPlacesSelected || item.placeLevels) {
          return (
            <FlexCol key={item.type.key} width="50%">
              <LabelValue
                label={item.type.namePlural}
                value={!hasAllPlacesSelected ? item.placeLevels : t('ignoring')}
              />
            </FlexCol>
          )
        }
        return undefined
      })}
    </FlexGrid>
  )
}

export default SegmentationDetails
